import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";
import { formatNameLinkField } from "services/utility/formatting";

export const columnInfo = [
  {
    name: "name",
    heading: i18n("columns.Name"),
    formatFunc: formatNameLinkField,
    fixed: true,
    linkField: true,
    sortable: true,
  },
];

export const LINE_ACTIONS = ["delete", "sync"];
export const BATCH_ACTIONS = ["delete", "sync"];

export function getEmptyRecord() {
  return {
    name: null,
    dayOfMonthDue: Decimal.ZERO,
    dueDays: Decimal.ZERO,
    dueNextMonthDays: Decimal.ZERO,
    discountDays: Decimal.ZERO,
    discountDayOfMonth: Decimal.ZERO,
    discountPercent: Decimal.ZERO,
    dateDiscountPercent: Decimal.ZERO,
  };
}
